import { differenceInMilliseconds, isSameMinute, isBefore } from 'date-fns';

/**
 * Sort agenda items by time, then alphabetically
 */
const compareAgendaItems = (a, b) => {
  // First agenda item dates
  const startA = new Date(a.start);
  const endA = new Date(a.end);
  // Second agenda item dates
  const startB = new Date(b.start);
  const endB = new Date(b.end);
  if (isSameMinute(startA, startB)) {
    const differenceA = differenceInMilliseconds(startA, endA);
    const differenceB = differenceInMilliseconds(startB, endB);

    if (differenceA > differenceB) {
      return -1;
    }
    if (differenceA < differenceB) {
      return 1;
    }
    // Fallback to sort by alphanumeric
    return new Intl.Collator().compare(a.name, b.name);
  }
  return isBefore(startA, startB) ? -1 : 1;
};

export default compareAgendaItems;
